export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: true,
};

export const PageName = '开果实奖励';
